import React, { useState, useEffect } from 'react';
import NavMenu from 'components/NavMenu';
import { useStyles, styles } from './DailyComplianceScreenStyles';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import TextEvents from 'app/components/TextEvents';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Button, Spin, Table } from 'antd';
import { Grid } from '@material-ui/core';
import DailyComplianceFilterComponent from './DailyComplianceFilterComponent/DailyComplianceFilterComponent';
import DailyComplianceTableComponent from './DailyComplianceTableComponent/DailyComplianceTableComponent';
import { fetchDailyCompliance } from "app/actions/DailyComplianceActions";

const DailyComplianceScreen = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    //const {siteId} = useSelector(state => state.Auth)

    const {
        isLoadExport
    } = useSelector(state => state.DailyComplianceReducer);

    const submit = () => {
        //dispatch();
    }

    const updateTable = () => {
        //dispatch();
    }

    useEffect(() => {
        // dispatch(fetchDailyCompliance({
        //     offset: 0,
        //     limit: 25
        // }));
    }, [dispatch]);

    return (
        <div className={classes.root}>
            <NavMenu SelectedIndex={props.history.location.pathname} isRepor={true} header='Cumplimiento diario de capacitaciones' isCommunicationStatus={false} />
            <CssBaseline />

            <div className={`${classes.content}`}>
                <div className={classes.appBarSpacer} />
                <div elevation={0} style={styles.titleBox}>
                    <Breadcrumbs aria-label="Breadcrumb">
                        <Link color="inherit" disabled>
                            Reportes
                        </Link>
                        <TextEvents
                            text="Reporte Cumplimiento Diario de Capacitaciones"
                            color="cotemar"
                            size='subtitle'
                            weight="bold"
                        />
                    </Breadcrumbs>

                    <Paper className={classes.rootPaper}>
                        <DailyComplianceFilterComponent/>
                        <DailyComplianceTableComponent/>
                    </Paper>
                </div>
            </div>
        </div>
    )
}

export default DailyComplianceScreen;